import common from "../common/lang";

var menuItems = {
    HOME: "innEBOK",
    EDIT: "EDYCJA",
    CREATE: "TWORZENIE",
    Measurements: "Pomiary",
    Agreements: "Umowy",
    MyAccount: "Moje konto"
};

var measurements = {
    PPM: "Punkt Poboru Medium",
    Medium: " Medium",
    CounterSerial: "Numer rejestratora",
    DeviceType: "Typ rejestratora",
    Tariff: "Grupa taryfowa",
    Phasicity: "Fazowość",
    Multiply: "Mnożna",
    DevicePlace: "Miejsce zainstalowania licznika",
    Consumption: "Zużycie",
    ConsumptionEnergy: "Zużycie(Energia)",
    ConversionCoeff: "Współczynnik konwersji",
    ReadoutDate: "Data odczytu",
    Zone: "Strefa",
    CounterState: "Wskazanie",
    ConsumptionDate: "Data obow. zużycia",
    Source: "Źródło pochodzenia odczytu",
    Measurement: "Typ pomiaru",
    AvgPeriod: "Okres uśredniania",
    ChartType: "Rodzaj wykresu",
    BarChart: "słupkowy",
    LineChart: "liniowy",
    Agreement: "Umowa",
    States: "Wskazania",
    AgreementFrom: "Umowa od",
    AgreementTo: "Umowa do",
    DateFrom: "Data od",
    DateTo: "Data do",
    From: "Od",
    To: "Do",
    Max_Power: "Moc maksymalna",
    ProfileChart: "Wykres zużycia",
    SameAxis:"Jedna skala"
}

var usercompanies = {
    MarketParticipants: "Uczestnicy rynku",
    Id: "Id",
    Nip: "NIP/ PESEL",
    Name: "Nazwa"
}

var agreements = {
    OwnerName: "Nazwa dostawcy",
    PartnerName: "Nazwa odbiorcy",
    IsArchive: "Archiwalna",
    Is_Permitted: "Widoczna",
    ShowAgreements: "Pokaż umowy",
    UserAgreements: "Umowy użytkownika"
}

var questions = {
    Delete_Object: "Czy chcesz usunąć obiekt?"
};

var dataStatus = {
    DataStatus_1: 'Dane pewne',
    DataStatus_2: 'Dane niepewne',
    DataStatus_3: 'Brak danych',
    DataStatus_4: 'Dane ręczne',
    DataStatus_5: 'Dane prognozowane',
    DataStatus_6: 'Dane poza strefą',
};

var measure = {
    ECP: "Energia Czynna Pobór (ECP)",
    ECO: "Energia Czynna Oddanie (ECO)",
    EBP: "Energia Bierna Pobór (EBP)",
    EBP_Q2: "Energia Bierna Pobór Q2 (EBP_Q2)",
    EBO: "Energia Bierna Oddanie (EBO)",
    EBO_Q3: "Energia Bierna Oddanie Q3 (EBO_Q3)",
    EPG: "Pobór Gazu (EPG)",
    EPG_WSK: "Wsp. Konwersji (EPG_WSK)",

    // ELECTRICAL
    ELECTRICAL_ECP: "Energia czynna pobrana (ECP)",
    ELECTRICAL_ECP_short: "ECP",
    
    ELECTRICAL_ECO: "Energia czynna oddana (ECO)",
    ELECTRICAL_ECO_short: "ECO",

    ELECTRICAL_EBP: "Energia bierna indukcyjna Q1 (EBI_Q1)",
    ELECTRICAL_EBP_short: "EBI_Q1",

    ELECTRICAL_EBP_Q2: "Energia bierna pojemnościowa Q2 (EBP_Q2)",
    ELECTRICAL_EBP_Q2_short: "EBP_Q2",

    ELECTRICAL_EBO_Q3: "Energia bierna indukcyjna Q3 (EBO_Q3)",
    ELECTRICAL_EBO_Q3_short: "EBI_Q3",

    ELECTRICAL_EBO: "Energia bierna pojemnościowa Q4 (EBP_Q4)",
    ELECTRICAL_EBO_short: "EBP_Q4",

    ELECTRICAL_EPG: "Błędna konfiguracja! (EPB)",
    ELECTRICAL_EPG_short: "EPG",

    ELECTRICAL_EPG_WSK: "Błędna konfiguracja! (EPG_WSPK)",
    ELECTRICAL_EPG_WSK_short: "EPG_WSPK",

    // GAS
    GAS_ECP: "Energia gazu (EGaz)",
    GAS_ECP_short: "EGaz",

    GAS_ECO: "Błędna konfiguracja! (ECO)",
    GAS_ECO_short: "Błędna konfiguracja! (ECO)",

    GAS_EBP: "Błędna konfiguracja! (EBP)",
    GAS_EBP_short: "Błędna konfiguracja! (EBP)",

    GAS_EBP_Q2: "Błędna konfiguracja! (EBP_Q2)",
    GAS_EBP_Q2_short: "Błędna konfiguracja! (EBP_Q2)",

    GAS_EBO: "Błędna konfiguracja! (EBO)",
    GAS_EBO_short: "Błędna konfiguracja! (EBO)",

    GAS_EBO_Q3: "Błędna konfiguracja! (EBO_Q3)",
    GAS_EBO_Q3_short: "Błędna konfiguracja! (EBO_Q3)",

    GAS_EPG: "Zużycie gazu (VGaz)",
    GAS_EPG_short: "VGaz",

    GAS_EPG_WSK: "Współczynnik konwersji (WSPK)",
    GAS_EPG_WSK_short: "WSPK",

    // WATER
    WATER_ECP: "Zużycie wody VWod [m^3]",
    WATER_ECP_short: "VWod [m^3]",

    WATER_ECO: "Błędna konfiguracja! (ECO)",
    WATER_ECO_short: "Błędna konfiguracja! (ECO)",

    WATER_EBP: "Błędna konfiguracja! (EBP)",
    WATER_EBP_short: "Błędna konfiguracja! (EBP)",

    WATER_EBP_Q2: "Błędna konfiguracja! (EBP_Q2)",
    WATER_EBP_Q2_short: "Błędna konfiguracja! (EBP_Q2)",

    WATER_EBO: "Błędna konfiguracja! (EBO)",
    WATER_EBO_short: "Błędna konfiguracja! (EBO)",

    WATER_EBO_Q3: "Błędna konfiguracja! (EBO_Q3)",
    WATER_EBO_Q3_short: "Błędna konfiguracja! (EBO_Q3)",

    WATER_EPG: "Błędna konfiguracja! (EPG)",
    WATER_EPG_short: "Błędna konfiguracja! (EPG)",

    WATER_EPG_WSK: "Błędna konfiguracja! (EPG_WSK)",
    WATER_EPG_WSK_short: "Błędna konfiguracja!(EPG_WSK)",

    // AIR
    AIR_ECP: "Zużycie powietrza (VPow)",
    AIR_ECP_short: "VPow",

    AIR_ECO: "Błędna konfiguracja! (ECO)",
    AIR_ECO_short: "Błędna konfiguracja! (ECO)",

    AIR_EBP: "Błędna konfiguracja! (EBP)",
    AIR_EBP_short: "Błędna konfiguracja! (EBP)",

    AIR_EBP_Q2: "Błędna konfiguracja! (EBP_Q2)",
    AIR_EBP_Q2_short: "Błędna konfiguracja! (EBP_Q2)",

    AIR_EBO: "Błędna konfiguracja! (EBO)",
    AIR_EBO_short: "Błędna konfiguracja! (EBO)",

    AIR_EBO_Q3: "Błędna konfiguracja! (EBO_Q3)",
    AIR_EBO_Q3_short: "Błędna konfiguracja! (EBO_Q3)",

    AIR_EPG: "Błędna konfiguracja! (EPG)",
    AIR_EPG_short: "Błędna konfiguracja! (EPG)",

    AIR_EPG_WSK: "Błędna konfiguracja! (EPG_WSK)",
    AIR_EPG_WSK_short: "Błędna konfiguracja!(EPG_WSK)",

    // STEAM
    STEAM_ECP: "Zużycie ciepła EPar [GJ]",
    STEAM_ECP_short: "EPar [GJ]",

    STEAM_ECO: "Zużycie nośnika VPar [m^3]",
    STEAM_ECO_short: "VPar [m^3]",

    STEAM_EBP: "Błędna konfiguracja! (EBP)",
    STEAM_EBP_short: "Błędna konfiguracja! (EBP)",

    STEAM_EBP_Q2: "Błędna konfiguracja! (EBP_Q2)",
    STEAM_EBP_Q2_short: "Błędna konfiguracja! (EBP_Q2)",

    STEAM_EBO: "Błędna konfiguracja! (EBO)",
    STEAM_EBO_short: "Błędna konfiguracja! (EBO)",

    STEAM_EBO_Q3: "Błędna konfiguracja! (EBO_Q3)",
    STEAM_EBO_Q3_short: "Błędna konfiguracja! (EBO_Q3)",

    STEAM_EPG: "Błędna konfiguracja! (EPG)",
    STEAM_EPG_short: "Błędna konfiguracja! (EPG)",

    STEAM_EPG_WSK: "Błędna konfiguracja! (EPG_WSK)",
    STEAM_EPG_WSK_short: "Błędna konfiguracja!(EPG_WSK)",

    // HEAT
    HEAT_ECP: "Energia cieplna (CO)",
    HEAT_ECP_short: "CO",

    HEAT_ECO: "Zużycie wody (VCO)",
    HEAT_ECO_short: "VCO",

    HEAT_EBP: "Błędna konfiguracja! (EBP)",
    HEAT_EBP_short: "Błędna konfiguracja! (EBP)",

    HEAT_EBP_Q2: "Błędna konfiguracja! (EBP_Q2)",
    HEAT_EBP_Q2_short: "Błędna konfiguracja! (EBP_Q2)",

    HEAT_EBO: "Błędna konfiguracja! (EBO)",
    HEAT_EBO_short: "Błędna konfiguracja! (EBO)",

    HEAT_EBO_Q3: "Błędna konfiguracja! (EBO_Q3)",
    HEAT_EBO_Q3_short: "Błędna konfiguracja! (EBO_Q3)",

    HEAT_EPG: "Błędna konfiguracja! (EPG)",
    HEAT_EPG_short: "Błędna konfiguracja! (EPG)",

    HEAT_EPG_WSK: "Błędna konfiguracja! (EPG_WSK)",
    HEAT_EPG_WSK_short: "Błędna konfiguracja!(EPG_WSK)",

    // NITROGEN
    NITROGEN_ECP: "Zużycie azotu (VAzot)",
    NITROGEN_ECP_short: "VAzot",

    NITROGEN_ECO: "Błędna konfiguracja! (ECO)",
    NITROGEN_ECO_short: "Błędna konfiguracja! (ECO)",

    NITROGEN_EBP: "Błędna konfiguracja! (EBP)",
    NITROGEN_EBP_short: "Błędna konfiguracja! (EBP)",

    NITROGEN_EBP_Q2: "Błędna konfiguracja! (EBP_Q2)",
    NITROGEN_EBP_Q2_short: "Błędna konfiguracja! (EBP_Q2)",

    NITROGEN_EBO: "Błędna konfiguracja! (EBO)",
    NITROGEN_EBO_short: "Błędna konfiguracja! (EBO)",

    NITROGEN_EBO_Q3: "Błędna konfiguracja! (EBO_Q3)",
    NITROGEN_EBO_Q3_short: "Błędna konfiguracja! (EBO_Q3)",

    NITROGEN_EPG: "Błędna konfiguracja! (EPG)",
    NITROGEN_EPG_short: "Błędna konfiguracja! (EPG)",

    NITROGEN_EPG_WSK: "Błędna konfiguracja! (EPG_WSK)",
    NITROGEN_EPG_WSK_short: "Błędna konfiguracja!(EPG_WSK)",

    // OTHER
    OTHER_ECP: "Zużycie medium (ZM)",
    OTHER_ECP_short: "ZM",

    OTHER_ECO: "Błędna konfiguracja! (ECO)",
    OTHER_ECO_short: "Błędna konfiguracja! (ECO)",

    OTHER_EBP: "Błędna konfiguracja! (EBP)",
    OTHER_EBP_short: "Błędna konfiguracja! (EBP)",

    OTHER_EBP_Q2: "Błędna konfiguracja! (EBP_Q2)",
    OTHER_EBP_Q2_short: "Błędna konfiguracja! (EBP_Q2)",

    OTHER_EBO: "Błędna konfiguracja! (EBO)",
    OTHER_EBO_short: "Błędna konfiguracja! (EBO)",

    OTHER_EBO_Q3: "Błędna konfiguracja! (EBO_Q3)",
    OTHER_EBO_Q3_short: "Błędna konfiguracja! (EBO_Q3)",

    OTHER_EPG: "Błędna konfiguracja! (EPG)",
    OTHER_EPG_short: "Błędna konfiguracja! (EPG)",

    OTHER_EPG_WSK: "Błędna konfiguracja! (EPG_WSK)",
    OTHER_EPG_WSK_short: "Błędna konfiguracja!(EPG_WSK)",


    "Chart_Electrical_Energy_ECP": "Energia czynna [kWh]",
    "Chart_Electrical_Power_ECP": "Moc czynna [kW]",

    "Chart_Electrical_Energy_ECO": "Energia bierna [kVArh]",
    "Chart_Electrical_Power_ECO": "Moc bierna [kVAr]",

    "Chart_Electrical_M3_ECO": "brak",
    "Chart_Electrical_M3_Power_ECO": "brak",



    "Chart_Gas_Energy_ECP": "Energia [kWh]",
    "Chart_Gas_Power_ECP": "Moc [kW]",

    "Chart_Gas_Energy_ECO": "brak",
    "Chart_Gas_Power_ECO": "brak",

    "Chart_Gas_M3_ECO": "Objętość [m^3]",
    "Chart_Gas_M3_Power_ECO": "Przepływ [m^3/h]",


    "Chart_Water_Energy_ECP": "Objętość [m^3]",
    "Chart_Water_Power_ECP": "Przepływ [m^3]",

    "Chart_Water_Energy_ECO": "brak",
    "Chart_Water_Power_ECO": "brak",

    "Chart_Water_M3_ECO": "brak",
    "Chart_Water_M3_Power_ECO": "brak",


    "Chart_Air_Energy_ECP": "Objętość [m^3]",
    "Chart_Air_Power_ECP": "Przepływ [m^3]",

    "Chart_Air_Energy_ECO": "brak",
    "Chart_Air_Power_ECO": "brak", 

    "Chart_Air_M3_ECO": "brak",
    "Chart_Air_M3_Power_ECO": "brak",


    "Chart_Steam_Energy_ECP": "Energia [GJ]",
    "Chart_Steam_Power_ECP": "Moc [GW]",

    "Chart_Steam_Energy_ECO": "Objętość [m^3]",
    "Chart_Steam_Power_ECO": "Przepływ [m^3]",

    "Chart_Steam_M3_ECO": "brak",
    "Chart_Steam_M3_Power_ECO": "brak",


    "Chart_Heat_Energy_ECP": "Energia [GJ]",
    "Chart_Heat_Power_ECP": "Moc [GW]",

    "Chart_Heat_Energy_ECO": "Objętość [m^3]",
    "Chart_Heat_Power_ECO": "Przepływ [m^3/h]", 

    "Chart_Heat_M3_ECO": "brak",
    "Chart_Heat_M3_Power_ECO": "brak",


    "Chart_Nitrogen_Energy_ECP": "Objętość [m^3]",
    "Chart_Nitrogen_Power_ECP": "Przepływ [m^3/h]", 

    "Chart_Nitrogen_Energy_ECO": "brak",
    "Chart_Nitrogen_Power_ECO": "brak",

    "Chart_Nitrogen_M3_ECO": "brak",
    "Chart_Nitrogen_M3_Power_ECO": "brak",


    "Chart_Other_Energy_ECP": "Objętość [m^3]",
    "Chart_Other_Power_ECP": "Przepływ [m^3/h]", 

    "Chart_Other_Energy_ECO": "brak",
    "Chart_Other_Power_ECO": "brak", 

    "Chart_Other_M3_ECO": "brak",
    "Chart_Other_M3_Power_ECO": "brak",
}


var exports = {
    "15min": "15min",
    "60min": "60min",
    XLSX: "XLSX",
    CSV: "CSV"
}

var localePL = {
    ...common["pl"],
    ...menuItems,
    ...questions,
    ...measurements,
    ...usercompanies,
    ...agreements,
    ...dataStatus,
    ...measure,
    ...exports
};

export default localePL;
